"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconFlagEs = void 0;
var React = __importStar(require("react"));
var IconFlagEs = function (props) { return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24" }, props),
    React.createElement("defs", null,
        React.createElement("polygon", { id: "ic_flag_es-a", points: "0 13.996 20 13.996 20 0 0 0" })),
    React.createElement("g", { fill: "none", fillRule: "evenodd", transform: "translate(2 5)" },
        React.createElement("polygon", { fill: "#FFF423", points: "0 10.396 20 10.396 20 3.593 0 3.593" }),
        React.createElement("path", { fill: "#E91C35", d: "M0 12.9961C0 13.5461.45 13.9961 1 13.9961L19 13.9961C19.55 13.9961 20 13.5461 20 12.9961L20 10.3941 0 10.3941 0 12.9961zM19 0L1 0C.45 0 0 .45 0 1L0 3.599 20 3.599 20 1C20 .45 19.55 0 19 0" })))); };
exports.IconFlagEs = IconFlagEs;
exports.IconFlagEs.defaultProps = {
    height: '30px',
    width: '30px'
};
exports.default = exports.IconFlagEs;
